__turbopack_context__.v({
  "AppPrivacy": "privacyPolicyComponent-module-scss-module__WJ81Oa__AppPrivacy",
  "cookies": "privacyPolicyComponent-module-scss-module__WJ81Oa__cookies",
  "privacyPolicyBlock": "privacyPolicyComponent-module-scss-module__WJ81Oa__privacyPolicyBlock",
  "privacyPolicyContainer": "privacyPolicyComponent-module-scss-module__WJ81Oa__privacyPolicyContainer",
  "privacyPolicyText": "privacyPolicyComponent-module-scss-module__WJ81Oa__privacyPolicyText",
  "privacyPolicyTitle": "privacyPolicyComponent-module-scss-module__WJ81Oa__privacyPolicyTitle",
});
